/**
 * @ref https://antoinevastel.com/bot%20detection/2018/01/17/detect-chrome-headless-v2.html
 */

/** check headless browser with user agent */ 
function checkUserAgent() {
  if (navigator.userAgent.includes('Headless')) {
    console.warn('headless check: user agent test failed.')
    return true
  }

  return false
}

/** check headless browser with webdriver */
function checkWebdriver() {
  if (navigator.webdriver) {
    console.warn('headless check: webdriver test failed.')
    return true
  }

  return false
}

/**
 * check headless browser with navigator permission
 * 因为只有这个方法是异步的，所以如果没有发现更严格的场景的话暂且不用
 */
// function checkPermission() {
//   return navigator.permissions.query({name:'notifications'}).then(function(permissionStatus) {
//     if(Notification.permission === 'denied' && permissionStatus.state === 'prompt') {
//       console.warn('headless check: permissions test failed.')
//       return true
//     } else {
//       return false
//     }
//   })
// }

/**
 * check headless browser
 * @returns true if headless browser
 */
export function checkHeadlessBrowser() {
  return checkUserAgent() || checkWebdriver()
}
